export default __webpack_public_path__ + "static/media/bg-complete-order-light.3e6d01c3.jpg";